import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, WritableSignal, computed, signal } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { FilesizePipe } from 'src/app/core/pipes/filesize.pipe';
import { DialogService } from 'src/app/core/services/dialog.service';
import { PuntiCampionamentoStoricoService } from '../punti-campionamento-storico.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-my-dialog-scaduti',
  standalone: true,
  imports: [
    MatDialogModule,
    MyButtonComponent,
    CommonModule,
    MatDividerModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    FilesizePipe
  ],
  templateUrl: './my-dialog-punti-campionamento.component.html',
  styleUrl: './my-dialog-punti-campionamento.component.css'
})
export class MyDialogPuntiCampionamentoComponent {
  isLoading = signal(false);
  canSend = computed(() => this.selectedFile() !== undefined);
  selectedFile: WritableSignal<any> = signal(undefined);
  isCheckingElaborazione = signal(false);
  dragging = signal(false);

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<MyDialogPuntiCampionamentoComponent>,
    private dialogService: DialogService,
    private readonly service: PuntiCampionamentoStoricoService,
    private location: Location
  ) {}

  onFileSelected(event: any) {
    this.selectedFile.set(event.target.files[0] ?? null);
  }

  resetForm() {
    this.selectedFile.set(undefined);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(true);
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(false);
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(false);
    if (event.dataTransfer?.files.length) {
      this.onFileSelected({ target: { files: event.dataTransfer.files } });
    }
  }

  onSendClick() {
    if (this.canSend() === true) {
      this.dialogService.confirm('Trasmetti', `Stai per trasmettere questo file. I dati saranno storicizzati sui server di AnTeA.`, {
        label: 'Conferma',
        color: 'primary',
        icon: 'done',
        raised: true
      }).subscribe((result) => {
        if (result === true) {
          const reader = new FileReader();
          reader.readAsDataURL(this.selectedFile());
          reader.onload = async () => {
            const base64: any = reader.result?.toString().split(',')[1]
            const filePayload = {
              name: this.selectedFile().name,
              type: this.selectedFile().type,
              base64: base64,
            }
            this.service.sendFile(filePayload).subscribe((value) => {
              console.log(value)

              if(!value.error){
                this.isCheckingElaborazione.set(true);
                this.startCheckingSaving(value.idElaborazione);
              }

              this.resetForm();
            })
          }
        }
      })
    }
  }

  startCheckingSaving (idElaborazione:string) {
    const intervalID = setInterval(() => {
      this.service.checkElaborazioneFile(idElaborazione).subscribe((checkControllo:any) => {
        console.log(checkControllo)
        if (checkControllo?.error) {
          this.dialogService.success('Errore nel salvataggio del file sui server di AnTeA.', false);
          clearInterval(intervalID); // Chiudi l'intervallo
          this.isCheckingElaborazione.set(false);
          this.resetForm();
        }
        if(checkControllo?.statoElaborazione.trim()=='ERRORE') {
          this.dialogService.error(`errore nel salvataggio del file sui server di AnTeA: ${checkControllo?.note}.`, false);
          clearInterval(intervalID); // Chiudi l'intervallo
          this.isCheckingElaborazione.set(false);
          this.resetForm();
        }
        if (checkControllo?.statoElaborazione=='ELABORAZIONE_CONCLUSA') {
          this.dialogService.success('Il file è stato elaborato e i dati sono stati salvati con successo sul database.', false);
          clearInterval(intervalID); // Chiudi l'intervallo
          this.isCheckingElaborazione.set(false);
          this.resetForm();
          if (this.location.path() == '/punti-campionamento/scaduti') {
            this.router.navigate(['punti-campionamento/scaduti']);
          } else if (this.location.path() == '/punti-campionamento/lista') {
            this.router.navigate(['punti-campionamento/lista'])
          }
        }
     
      });
    }, 5000); 
  }



  closeModal(): void {
    this.dialogRef.close();
  }
}
